<script>
  import { selected_text_case } from './../stores.js'
  import { createEventDispatcher } from 'svelte'
  const dispatch = createEventDispatcher()

  export let button_text_case

  function toggleCase(){
    $selected_text_case = $selected_text_case === button_text_case ? undefined : button_text_case
  }
</script>

<button type='button' 
        class:active="{$selected_text_case === button_text_case}"
        on:click={toggleCase}>
        <slot></slot>
</button>

<style>
  button {
    user-select: none;
    padding: 0;
    border: none;
    outline: none;
    color: var(--c-text-faded);
    background-color: transparent;
    line-height: 4rem;
  }
  button:hover {
    cursor: pointer;
    color: var(--c-text);
  }
  button.active {
    color: var(--c-accent);
  }
</style>